import { createGlobalState } from 'react-hooks-global-state';
import { emptyDatesObject } from '../../../availability_calendar/AvailabilityCalendar';

export const { GlobalStateProvider, useGlobalState } = createGlobalState({
  loadingCalenderDateAvailability: false,
  bookingDates: [{ ...emptyDatesObject }], // Initial empty array to hold selected date range
  availableTime: null,
  packageId: null,
  accommodationCalendarKey: 0,
  editBookingDetails: null,
  arrivalTime: null,
  departureTime: null,
  packageData: null,
  userSelectedTicket: null,
  userSelectedSwims: [],
  userSelectedDoubleSwim: [],
  lakeListInfo: null,
  userSelectedLakeId: null,
  userSelectedBookingType: null,
  noOfTickets: [],
  customSlotData: null,
  customPropertyDetails: [],
  userSelectedBookingPackage: null,
});
